/**
 * Ancho máximo para layout “una columna” (lista o significado), alineado con
 * AppHeader (navbar móvil) y Meaning.js (bottomNavReserve).
 */
export const DICTIONARY_NARROW_LAYOUT_MAX_PX = 991

export function isDictionaryNarrowLayout() {
    if (typeof window === 'undefined') return false
    return window.innerWidth <= DICTIONARY_NARROW_LAYOUT_MAX_PX
}
